import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs from '../../core/configs/dayjs';

interface IConsumerEntity {
	id: number;
	name: string;
	isGroup: boolean;
	avatar: AvatarEntity;
	firstName: string;
	lastName: string;
	mail: string;
	description: string;
}

const entityDefaults: IConsumerEntity = {
	id: -1,
	name: '',
	isGroup: false,
	avatar: AvatarEntity.build('user'),
	firstName: '',
	lastName: '',
	mail: '',
	description: '',
};

export class ExpositionConsumerEntity implements IConsumerEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public name = entityDefaults.name;
	public isGroup = entityDefaults.isGroup;
	public avatar = entityDefaults.avatar;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public mail = entityDefaults.mail;
	public description = entityDefaults.description;

	public static build(
		params: Partial<IConsumerEntity> = {}
	): ExpositionConsumerEntity {
		const instance = new ExpositionConsumerEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.name = params.name ?? entityDefaults.name;
		instance.isGroup = params.isGroup ?? entityDefaults.isGroup;
		if (params.name) {
			instance.avatar = AvatarEntity.build(params.name, params.isGroup ? 1 : 2);
		}
		instance.firstName = params.firstName ?? entityDefaults.firstName;
		instance.lastName = params.lastName ?? entityDefaults.lastName;
		instance.mail = params.mail ?? entityDefaults.mail;
		instance.description = params.description ?? entityDefaults.description;
		return instance;
	}
}
